export default __webpack_public_path__ + "static/media/Remove-Account.97396c2a.png";